import {Component, OnInit} from "@angular/core";
import {FacadeService} from "../../service-facade/facade.service";
import {Router} from "@angular/router";
import {CoreService} from "../../services/core.service";
import {CREATE_LOGIN_PATH, HOME_PATH, JOINT_MAINTENANCE_APPLICATION_PATH, REVIEW_PATH, SELECT_ACCOUNTS_PATH, SUCCESS_PATH } from "../../constants";
import {MainLayoutService} from "../../services/main-layout.service";
import {PageBreakRules} from "./rules/page-break-rules.abstract";
import {PageBreakRulesFactory} from "./rules/page-break-rules.factory";

@Component({
  selector: 'page-break',
  templateUrl: './page-break.component.html',
  styleUrls: ['./page-break.component.scss'],
  providers: [
    {
      provide: PageBreakRules,
      useFactory: PageBreakRulesFactory,
      deps: [
        FacadeService
      ]
    }
  ]
})

export class PageBreakComponent implements OnInit {
  public isBaskBrand = false;
  public isForJointMaintenance = false;

  constructor(
    private facadeService: FacadeService,
    private router: Router,
    private coreService: CoreService,
    private mainLayout: MainLayoutService,
    public pageBreakRules: PageBreakRules
  ) {
  }

  ngOnInit() {
    this.isForJointMaintenance = this.facadeService.isInJointMaintenanceFlow$.value;
    this.isBaskBrand = this.facadeService.isBaskBrand();
    this.mainLayout.setPageTitle(`Get Started`);
  }

  onClickOfGetStarted() {
    if(this.isForJointMaintenance) {
      this.coreService.navigate(`/${JOINT_MAINTENANCE_APPLICATION_PATH}`);
    }
    else if(this.facadeService.isInAuthenticatedFlow()) {
      this.coreService.navigate(`/${REVIEW_PATH}`);
    }
    else {
     this.coreService.navigate(`/${SELECT_ACCOUNTS_PATH}`);
    }
  }

}
